import { LookupValue } from "./lookup.model";

export enum FittingImage {
  Branching = 'https://assets.tdwilliamson.com/img/PolyStopp/PE-Branching-Fitting.png',
  Plugging = 'https://assets.tdwilliamson.com/img/PolyStopp/PE-Plugging-Fitting.png',
  PluggingMachine = 'https://assets.tdwilliamson.com/img/PolyStopp/PluggingMachine.png',
  TappingMachine = 'https://assets.tdwilliamson.com/img/PolyStopp/TappingMachine.png'
}

export enum Measurement {
  Any = 'Any',
  Imperial = 1,
  Metric = 2
}

export enum Application {
  Branching = 'Branching',
  Plugging = 'Plugging',
  Any = 'Any'
}

export enum EquipmentType {
  Tapping = 6,
  Plugging = 9,
  Valve = 1,
  Completion = 15,
  MaintenanceKit = 27
}

export interface PEFilter {
  measurement: Measurement,
  application: Application,
  familyID?: number,
  subFamilyID?: number,
  sizes: number[] // the ids of the PEFitting_PipeSize (select many)
}

export interface PEEquipmentSelector extends PEFilter {
  familyID?: number,
}

export interface PEAccessorySelector extends PEEquipmentSelector {
  subFamilyID?: number
}

// Generated by https://quicktype.io

export interface PEEquipmentFamily extends LookupValue {
  childEquipment: PEEquipmentFamily[],
  parentID?: number
}

export interface PEFitting {
  id: number;
  partNumber: string;
  productName: string;
  description: string;
  pipeSize: string;
  measurement: string;
  isPreferred: boolean;
  applicationType: string;
}

// Generated by https://quicktype.io

export interface PEFittingProduct {
  id: number;
  partNumber: string;
  productName: string;
  description: string;
  pipeSizeID: number;
  notes: null;
  inactiveDate: null;
  hemisphereId: number;
  isPreferred: boolean;
  applicationType: string;
  createdDate: string;
  createdBy: string;
  updatedDate: string;
  updatedBy: string;
  pePipeSize: LookupValue;
  hemisphere: LookupValue;
}

export interface PEEquipmentProduct {
  id: number;
  partNumber: string;
  productName: string;
  description: string;
  pipeSize: string;
  measurement: string;
  isPreferred: boolean;
  familyID: number;
  subFamilyID: number;
  url: string;

  peEquipmentSizes: PEEquipmentSize[];
  equipmentFamily: PEEquipmentFamily;
  subEquipmentFamily: PEEquipmentFamily;
}

export interface PEEquipmentSize {
  peSizeID: number,
  peEquipmentProductID: number,
  createdDate: Date,
  createdBy: string,
  updatedDate: Date,
  updatedBy: string

  peSize: LookupValue;
}

export interface PEEquipmentProduct {

}

